import React from 'react'

// Download arrow (into a tray). Uses `currentColor` so it inverts with the
// button text on hover.
export const DownloadIcon = () => (
  <svg width='11' height='10' viewBox='0 0 11 10' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path d='M8.84866 3.59486L5.20167 7.34603L1.55469 3.59486M5.20167 7.34603L5.20167 0' stroke='currentColor' strokeWidth='0.88096' />
    <path d='M0.4375 7.34619V9.53438H10.1281V7.34619' stroke='currentColor' strokeWidth='0.88096' />
  </svg>
)

// Chevron used by the contact form's topic select. Drawn pointing right (as in
// Figma) and rotated by the styled wrapper so open/closed states can animate.
export const ChevronIcon = () => (
  <svg width='5' height='12' viewBox='0 0 4.835 11.6936' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path d='M0 11.5039L2.87729 5.84679L0 0.189711L0.252948 0L4.835 5.53324V6.16298L0.252948 11.6936L0 11.5039Z' fill='currentColor' />
  </svg>
)

// Down chevron on the mobile stage accordion rows. `currentColor` so it follows
// the header text; the styled wrapper flips it when the row opens.
export const ChevronDownIcon = () => (
  <svg width='21' height='10' viewBox='0 0 20.5 9.64287' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path d='M0.750014 0.750014L10.25 8.89287L19.75 0.750014' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
